import { render } from "./DashboardFilter.vue?vue&type=template&id=15e83bf8&scoped=true"
import script from "./DashboardFilter.vue?vue&type=script&lang=js"
export * from "./DashboardFilter.vue?vue&type=script&lang=js"

import "./DashboardFilter.vue?vue&type=style&index=0&id=15e83bf8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e83bf8"]])

export default __exports__